import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { ApprovalDecisionActions } from '../../_components/Shared/ApprovalDecisionActions';
import { getApprovalCapabilities, isFinalApprovalDecision } from '../../_services/approval.service';
import { approvalStatusStyle } from './qValueReportFormLock';

export default function QValueReportApprovalBar({
    recordType,
    recordId,
    approvalLabel,
    rejectionReason,
    onDecisionComplete,
}) {
    const [capabilities, setCapabilities] = useState(null);

    useEffect(() => {
        if (!recordId || !recordType) {
            setCapabilities(null);
            return undefined;
        }
        let cancelled = false;
        getApprovalCapabilities(recordType, recordId)
            .then((caps) => {
                if (!cancelled) setCapabilities(caps);
            })
            .catch(() => {
                if (!cancelled) setCapabilities(null);
            });
        return () => { cancelled = true; };
    }, [recordType, recordId]);

    const canApprove = capabilities && capabilities.canApprove;
    const canReject = capabilities && capabilities.canReject;

    return (
        <div className="mb-3">
            {approvalLabel && (
                <div className="mb-2" style={approvalStatusStyle(approvalLabel)}>
                    Approval status: {approvalLabel}
                </div>
            )}
            {rejectionReason && approvalLabel === 'Rejected' && (
                <Alert variant="danger" className="py-2">
                    <strong>Rejection reason:</strong> {rejectionReason}
                </Alert>
            )}
            {(canApprove || canReject) && (
                <ApprovalDecisionActions
                    recordType={recordType}
                    recordId={recordId}
                    recordLabel="report"
                    currentLevel={capabilities.currentLevel}
                    canApprove={canApprove}
                    canReject={canReject}
                    onDecision={(result, meta) => {
                        const msg = meta.action === 'reject'
                            ? 'Report rejected.'
                            : isFinalApprovalDecision(result)
                                ? 'Report fully approved.'
                                : 'Approval recorded. Pending next level.';
                        window.alert(msg);
                        if (onDecisionComplete) onDecisionComplete();
                    }}
                    onError={(err) => window.alert(err.message || 'Approval action failed.')}
                />
            )}
        </div>
    );
}
